import { useMemo, useState , useEffect } from "react";
import { useNavigate } from "react-router-dom";
import MultiTable from "../../../Common/MUITable";
import { filterRowsByCriteria } from "./reportCommon";
import {
  DEFAULT_HOOK_LOADER_FILTERS,
} from "./staticReportData";
import HookLoaderFilter from "./HookLoaderFilter";
import DelhiReportExport from "./DelhiReportExport";
import {HookLoaderReport as getHookLoaderReport, GetAllCircles,} from "./ReportApi";
import { getTodayEndDateTime, getTodayStartDateTime } from "./reportCommon";

const formatTons = (value) => {
  if (value === null || value === undefined || value === "") return "";
  if (Number(value) === 0) return "0";
  return `${value}T`;
};

const buildReportRow = (row) => ({
  ...row,
  tonnageDisplay: formatTons(row.tonnage),
});

const buildTotalRow = (rows) => {
  const totals = rows.reduce(
    (acc, row) => ({
      totalTrip: acc.totalTrip + (Number(row.totalTrip) || 0),
      tonnage: acc.tonnage + (Number(row.tonnage) || 0),
    }),
    { totalTrip: 0, tonnage: 0 }
  );

  return {
    wardName: "Total",
    vehicleNo: "",
    isTotalRow: true,
    totalTrip: totals.totalTrip,
    tonnage: totals.tonnage,
    tonnageDisplay: formatTons(totals.tonnage),
  };
};

const totalCellStyle = { fontWeight: 700 };

const renderTotalAwareCell = (field) => (row) =>
  row.isTotalRow ? (
    <span style={totalCellStyle}>{row[field]}</span>
  ) : (
    row[field]
  );

const exportColumns = [
  { label: "Ward", field: "wardName" },
  { label: "Vehicle no", field: "vehicleNo" },
  { label: "Total Trip", field: "totalTrip" },
  { label: "Tonnage", field: "tonnageDisplay" },
];

const HookLoaderReport = () => {
  const navigate = useNavigate();
  const [filters, setFilters] = useState(DEFAULT_HOOK_LOADER_FILTERS);
  const [appliedFilters, setAppliedFilters] = useState(
    DEFAULT_HOOK_LOADER_FILTERS
  );
const [reportData, setReportData] = useState([]);
const [loadingReport, setLoadingReport] = useState(false);
const [wardOptions, setWardOptions] = useState([]);
const [loadingWards, setLoadingWards] = useState(false);
useEffect(() => {

  const loadHookLoaderReport = async () => {

  setLoadingReport(true);

  try {
    const fromDate = appliedFilters.fromDate || "";
    const toDate = appliedFilters.toDate || "";



    // Validate date range
    if (fromDate && toDate) {
      const from = new Date(fromDate);
      const to = new Date(toDate);

      if (from > to) {
        console.error("From date cannot be greater than To date");
        setReportData([]);
        setLoadingReport(false);
        return;
      }
    }

    const requestPayload = {
      circleId: appliedFilters.wardId || null,
      vehicleNo: appliedFilters.vehicleNo || null,
      fromDate: fromDate || null,
      toDate: toDate || null,
    };


    const response = await getHookLoaderReport(requestPayload);

    const data = response?.data?.data || [];

    const formattedData = data
      .filter((row) => !row.IsTotalRow)
      .map((row) => ({
        vehicleNo: row.VehicleNumber,
        totalTrip: row.TotalTrip,
        tonnage: row.Tonnage,
        wardId: row.WardId,
        wardName: row.WardName,
      }));

    setReportData(formattedData);
  } catch (error) {
    console.error(" API ERROR:", error);
    setReportData([]);
  } finally {
    console.log(" API FINISHED");
    setLoadingReport(false);
  }
};
  loadHookLoaderReport();
}, [appliedFilters]);

useEffect(() => {
  const loadWards = async () => {
    setLoadingWards(true);

    try {
      const response = await GetAllCircles();

      console.log("🔥 GET ALL CIRCLES RESPONSE:", response);
const data = response?.data?.data || [];

console.log("🔥 CIRCLE DATA:", data);

const formattedWards = data.map((circle) => ({
  wardId: circle.circleId,
  wardName: circle.circleName,
}));



setWardOptions(formattedWards);
    } catch (error) {
      console.error("❌ GET ALL CIRCLES ERROR:", error);
      setWardOptions([]);
    } finally {
      setLoadingWards(false);
    }
  };

  loadWards();
}, []);
const filteredRows = useMemo(() => {
  const rows = reportData.map(buildReportRow);

  if (rows.length === 0) return [];

  return [...rows, buildTotalRow(rows)];
}, [reportData]);
  const handleSearch = (values) => {
    setAppliedFilters(values);
  };

const handleReset = () => {
  const resetValues = {
    wardId: "",
    vehicleNo: "",
    fromDate: getTodayStartDateTime(),
    toDate: getTodayEndDateTime(),
  };

  setFilters(resetValues);
  setAppliedFilters(resetValues);
};

 

const handleTotalTripClick = (row) => {


  if (row.isTotalRow) {
    navigate("/hook-loader-inner-report", {
      state: {
        showAllTrips: true,
        appliedFilters: {
          ...appliedFilters,
          fromDateTime: appliedFilters.fromDate || "",
          toDateTime: appliedFilters.toDate || "",
        },
      },
    });

    return;
  }

  navigate("/hook-loader-inner-report", {
    state: {
      showAllTrips: false,
      parentRow: {
        vehicleNo: String(row.vehicleNo),
        wardId: row.wardId,
        wardName: row.wardName,
        totalTrip: row.totalTrip,
        tonnage: row.tonnage,
      },
      appliedFilters: {
        ...appliedFilters,
        fromDateTime: appliedFilters.fromDate || "",
        toDateTime: appliedFilters.toDate || "",
      },
    },
  });
};

  const tripCountLinkStyle = {
    cursor: "pointer",
    color: "#003366",
    textDecoration: "underline",
    fontWeight: 600,
  };

  const tableColumns = [
    {
      label: "Ward",
      field: "wardName",
      width: "120px",
      render: renderTotalAwareCell("wardName"),
    },
    {
      label: "Vehicle no",
      field: "vehicleNo",
      width: "150px",
      render: renderTotalAwareCell("vehicleNo"),
    },
    {
      label: "Total Trip",
      field: "totalTrip",
      width: "120px",
      render: (row) => (
        <span
          style={
            row.isTotalRow
              ? { ...tripCountLinkStyle, ...totalCellStyle }
              : tripCountLinkStyle
          }
          onClick={() => handleTotalTripClick(row)}
        >
          {row.totalTrip}
        </span>
      ),
    },
    {
      label: "Tonnage",
      field: "tonnageDisplay",
      width: "120px",
      render: renderTotalAwareCell("tonnageDisplay"),
    },
  ];

  return (
    <div className="content text-start">
      <div className="page-content">
        <div className="d-flex flex-column flex-md-row justify-content-between align-items-start gap-3 mt-3 mb-3">
          <div className="me-md-3">
            <h5 className="mb-1 fw-semibold">Hook Loader Report</h5>
           
          </div>
          <DelhiReportExport
            reportData={filteredRows}
            reportTitle="Hook Loader"
            columns={exportColumns}
            fileName="HookLoaderReport"
          />
        </div>

        <div className="card shadow mb-3">
          <div className="card-body">
            <HookLoaderFilter
              initialValues={filters}
              wardOptions={wardOptions}
              onSearch={(values) => {
                setFilters(values);
                handleSearch(values);
              }}
              onReset={handleReset}
            />
          </div>
        </div>

        <div className="card shadow">
          <div className="card-body">
            <div className="table-responsive">
              <MultiTable
                needSRNumber
                columns={tableColumns}
                rows={filteredRows}
                tableHeight={500}
                hasTotalRow
                rowsPerPageOptions={[10, 25, 50, 100]}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HookLoaderReport;
